export type ScrollToTargetOptions = {
  root?: HTMLElement | null;
  behavior?: ScrollBehavior;
};

const getScrollRoot = (element: HTMLElement, root?: HTMLElement | null) => {
  if (root) return root;
  return element.closest('main.overflow-y-auto') as HTMLElement | null;
};

const clampScrollTop = (value: number, root: HTMLElement) => {
  const max = Math.max(0, root.scrollHeight - root.clientHeight);
  return Math.min(Math.max(0, value), max);
};

export const scrollToTarget = (id: string, options: ScrollToTargetOptions = {}) => {
  if (typeof document === 'undefined') return;

  const root = options.root ?? null;
  const safeId = typeof CSS !== 'undefined' && 'escape' in CSS ? CSS.escape(id) : id;
  const element = root
    ? root.querySelector<HTMLElement>(`#${safeId}`)
    : document.getElementById(id);

  if (!element) return;

  const scrollRoot = getScrollRoot(element, root);
  if (!scrollRoot) {
    element.scrollIntoView({ behavior: options.behavior ?? 'smooth', block: 'start' });
    return;
  }

  const rootRect = scrollRoot.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  const scrollMarginTop = Number.parseFloat(getComputedStyle(element).scrollMarginTop || '0');
  const offset = Number.isNaN(scrollMarginTop) ? 0 : scrollMarginTop;
  const top = elementRect.top - rootRect.top + scrollRoot.scrollTop - offset;

  scrollRoot.scrollTo({
    top: clampScrollTop(top, scrollRoot),
    behavior: options.behavior ?? 'smooth',
  });
};
